<template>
  <div :class="['day-tag', type]">
    <span>{{ getTimeTag }}</span>
  </div>
</template>

<script setup lang="ts">
import { localize } from '@/core/gambits';
import { getShortDayOfWeek } from '@/core/helpers/date.helper';
import GambitHelper from '@/core/helpers/gambit.helper';
import { GamDateType } from '@/views/composables/constants/components/gamGambit.constants';
import { useMinuteClock } from '@/views/composables/hooks/useMinuteClock';
import { computed } from 'vue';

interface DayTagProps {
  date: string;
  end?: string | null;
}

const props = defineProps<DayTagProps>();

const now = useMinuteClock();

const type = computed(() => {
  return GambitHelper.getGambitsDateType(props.date, false, props.end, now.value);
});

const getTimeTag = computed(() => {
  if (!props.date) return;

  if (type.value === GamDateType.DAY) {
    return getShortDayOfWeek(props.date);
  } else {
    return localize(`gambit.card.date.time.type.${type.value}`);
  }
});
</script>

<style scoped lang="scss">
.day-tag {
  font-weight: 500;
  transition: color var(--transition-fast);
  text-transform: uppercase;

  &.soon,
  &.now {
    background: var(--color-linear-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
  }

  &.tomorrow,
  &.today {
    background: var(--color-white);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
  }
}
</style>
